export const AWARD_LIST_REQUEST = 'AWARD_LIST_REQUEST'
export const AWARD_LIST_SUCCESS = 'AWARD_LIST_SUCCESS'
export const AWARD_LIST_FAIL    = 'AWARD_LIST_FAIL'

export const AWARD_DETAILS_REQUEST = 'AWARD_DETAILS_REQUEST'
export const AWARD_DETAILS_SUCCESS = 'AWARD_DETAILS_SUCCESS'
export const AWARD_DETAILS_FAIL    = 'AWARD_DETAILS_FAIL'
export const AWARD_DETAILS_RESET   = 'AWARD_DETAILS_RESET'

export const AWARD_CREATE_REQUEST = 'AWARD_CREATE_REQUEST'
export const AWARD_CREATE_SUCCESS = 'AWARD_CREATE_SUCCESS'
export const AWARD_CREATE_FAIL    = 'AWARD_CREATE_FAIL'
export const AWARD_CREATE_RESET   = 'AWARD_CREATE_RESET'

export const AWARD_UPDATE_REQUEST = 'AWARD_UPDATE_REQUEST'
export const AWARD_UPDATE_SUCCESS = 'AWARD_UPDATE_SUCCESS'
export const AWARD_UPDATE_FAIL    = 'AWARD_UPDATE_FAIL'
export const AWARD_UPDATE_RESET   = 'AWARD_UPDATE_RESET'

export const AWARD_DELETE_REQUEST = 'AWARD_DELETE_REQUEST'
export const AWARD_DELETE_SUCCESS = 'AWARD_DELETE_SUCCESS'
export const AWARD_DELETE_FAIL    = 'AWARD_DELETE_FAIL'
